import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'dashboard-source-of-contacts',
  storeModule.createStoreModule('dashboard-source-of-contacts', {
    fetchListURL: 'dashboard/source-of-contacts'
  })
)
